'use client'
import {SanityImageType} from '@local/types'
import {SlideshowNative, SanityImage} from '@local/ui/components'
import {useRef} from 'react'
import {useResizeObserver} from '@local/hooks'
import {cx} from '@local/utils/cx'

type ImageSliderProps = {
	images: SanityImageType[]
	containerClassName?: string,
	className?: string,
}

export const ImageSlider = ({images, containerClassName, className}: ImageSliderProps) => {
	const slideshowRef = useRef(null)
	const scrollContainerWidth = useRef<number>(0)
	const childrenRefs = useRef<Array<HTMLDivElement>>([])

	useResizeObserver(slideshowRef, ({borderBoxSize}) => {
		const slideshowWidth = borderBoxSize[0].inlineSize * images.length
		const childWidth = borderBoxSize[0].inlineSize
		scrollContainerWidth.current = slideshowWidth - childWidth
	})

	return (
		<SlideshowNative
			containerRef={slideshowRef}
			containerClassName={cx('relative w-full lg:w-[335px] h-[500px] overflow-hidden rounded-10', containerClassName)}
			withDotNavigation
			dotNavigationClassName={cx(
				'absolute bottom-20 left-1/2 -translate-x-1/2 justify-center gap-14',
				'[&>button]:w-34 [&>button]:bg-white',
			)}
			className={cx('w-full lg:w-[335px] h-[500px] relative overflow-hidden rounded-10', className)}>
			{images.map((image, index) => (
				<figure
					key={image._key}
					ref={node => { childrenRefs.current[index] = node as HTMLDivElement }}
					className='w-full lg:w-[335px] h-full relative will-change-transform overflow-hidden rounded-lg'>

					<SanityImage
						image={image}
						width={335}
						height={500}
						desktopWidth={335}
						className='h-full w-full object-cover rounded-10'
						fill />
				</figure>
			))}
		</SlideshowNative>
	)
}
